import { render, staticRenderFns } from "./Swiper.vue?vue&type=template&id=3b42310a&scoped=true"
import script from "./Swiper.vue?vue&type=script&lang=js"
export * from "./Swiper.vue?vue&type=script&lang=js"
import style0 from "./Swiper.vue?vue&type=style&index=0&id=3b42310a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b42310a",
  null
  
)

export default component.exports